export const COOKIE_CONSENT_KEY = 'cookieConsent';

const CONSENT_GRANTED = {
  ad_storage: 'granted',
  analytics_storage: 'granted',
  ad_user_data: 'granted',
  ad_personalization: 'granted',
  personalization_storage: 'granted',
  functionality_storage: 'granted',
  security_storage: 'granted',
};

const CONSENT_DENIED = {
  ad_storage: 'denied',
  analytics_storage: 'denied',
  ad_user_data: 'denied',
  ad_personalization: 'denied',
  personalization_storage: 'denied',
  functionality_storage: 'granted',
  security_storage: 'granted',
};

export function getStoredCookieConsent() {
  if (typeof window === 'undefined') return null;
  try {
    const value = window.localStorage.getItem(COOKIE_CONSENT_KEY);
    return value === 'accepted' || value === 'rejected' ? value : null;
  } catch {
    return null;
  }
}

export function getGoogleConsentState(value) {
  return value === 'accepted' ? CONSENT_GRANTED : CONSENT_DENIED;
}

export function applyGoogleConsent(value) {
  if (typeof window === 'undefined' || !window.gtag) return;
  window.gtag('consent', 'update', getGoogleConsentState(value));
}

export function saveCookieConsent(value) {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(COOKIE_CONSENT_KEY, value);
  applyGoogleConsent(value);
}
